import { format, isValid, parse } from "date-fns";
export const getAge = (birthDate) => Math.floor((new Date().getTime() - new Date(birthDate).getTime()) / 3.15576e10);
export const parseDate = (date, fallback = "—") => {
    if (!isValid(parse(date, "yyyy-MM-dd", new Date())))
        return fallback; // Display fallback string to prevent empty cells
    return format(parse(date, "yyyy-MM-dd", new Date()), "MM/dd/yyyy");
};
export const normalizeString = (str) => str.toLowerCase().trim();
